import { render, staticRenderFns } from "./BannerSlider.vue?vue&type=template&id=496a17f2&scoped=true"
import script from "./BannerSlider.vue?vue&type=script&lang=js"
export * from "./BannerSlider.vue?vue&type=script&lang=js"
import style0 from "./BannerSlider.vue?vue&type=style&index=0&id=496a17f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a17f2",
  null
  
)

export default component.exports